import React from 'react';
import { Container } from '../components.js';
import StringUtils from '../../utils/stringutils.js';

class HorizontalContainer  extends React.Component {

	constructor(props) {
		super(props);

		this.getData = this.getData.bind(this);

		this.state = { response : {data :{}, dataError: false}};
	}

	componentDidMount() {
		
		if(this.state.response.data !== null && Object.keys(this.state.response.data).length === 0 && this.state.response.dataError === false) {
			this.getData();
		}
	}

	getData() {
		
		var component = this;

		var callback = function(response) {
			if(response.code === 200) {
				if(response.detail !== "Report generated") {
						component.setState({response: { data : {}, dataError : response.detail}});
				}
				else {
					component.setState({response: { data : response.data, dataError : response.detail}});
				}
			}
			else {
				component.setState({response: { data : {}, dataError : response.detail}});
			}
		};
		
		this.props.objectToCall[this.props.apiCall](callback);
	}

	render() {
		const iconAndDataSize = {
			width: '30%',
			height: '80%'
		};

		const containerSize = this.props.size;

	  	var containerContent = [];

	  	for(var key in this.state.response.data) {
	  		var content = (<IconAndData key={key + "-" + this.props.type} size={iconAndDataSize} type={key} data={this.state.response.data[key]} />);
	  		containerContent.push(content);
	  	}

	  	if(containerContent.length == 0) {
	  		containerContent = 'Loading...';
	  	}
	  	else {
	  		containerContent = (<div className="App-ChartsBoxRow1 space-around">{containerContent}</div>);
	  	}

	  	//<div className="Data-Div"><img className="Data-Icon" src="/images/avg_response_amt.png" alt="Bullseye Icon" /><br />{'$' + this.state.averages.data.average_amount.toString()} </div> ) : (this.state.responses.dataError) ? 'Unable to get response data' : 'Loading...'
  		return (
      		<Container key={this.props.type + "Goals"} moreClass={'MinPad ' + this.props.addClass} 
      		moreTitleClass={"App-ChartsTitle"} titles={[{'label' : this.props.title, 'onClick' : ''}]} 
      		contents={containerContent} size={containerSize} onclick={this.props.onclick} bgcolor="rgb(100, 160, 67)" />
  		);
	}
}

function IconAndData (props) {
	var icon = 'x.png', text = 'Unknown', value = props.data;

	switch (props.type) {
	case 'goals_complete':
		icon = 'goals_complete.png';
		text = 'Goals Completed';
		value = StringUtils.numberWithCommas(value);
		break;
	case 'goals_rewards':
		icon = 'goals_rewards.png';
		text = 'Rewards Paid';
		value = StringUtils.dollar_format(value, true);
		break;
	case 'goals_penalties':
		icon = 'goals_penalties.png';
		text = "Break the Safe™ Penalty";
		value = StringUtils.dollar_format(value, true);
		break;
	case 'average_amount':
		icon = 'avg_goal_amt.png';
		text = 'Goal Amount';
		value = StringUtils.dollar_format(value, true);
		break;
	case 'average_length':
		icon = 'avg_goal_len.png';
		text = 'Goal Length';
		value = (<div className='shift-box'>{StringUtils.numberWithCommas(value)}<div className='small-value-text center-right-text'> months</div></div>);
		break;
	case 'average_goals':
		icon = 'avg_goal_user.png';
		text = '# of Goals';
		value = (<div className='shift-box'>{StringUtils.numberWithCommas(value)}<div className='small-value-text center-right-text'> per user</div></div>);
		break;
	default:
		break;
	}

	return (
		<div className='icon-and-data'>
			<img src={process.env.PUBLIC_URL + "images/" + icon} />
			<div className='big-value-text'>{value}</div>
			<div className='small-value-text'>{text}</div>
		</div>
	);
}

export {HorizontalContainer, IconAndData};








